import { useMutation } from '@tanstack/react-query'

import { SingleQuestionFiltersModel } from '@/domain/model/question'

import { invalidateLoadQuestionByResourceId } from '../questions/useLoadQuestionByResourceId'
import {
  lockQuestionsByFormIdForMeasure,
  LockQuestionsByFormIdForMeasureProps,
} from './services/lockQuestionsByFormIdForMeasure'

export const useLockQuestionsByFormIdForMeasure = (
  params: SingleQuestionFiltersModel
) => {
  const mutation = useMutation({
    mutationFn: async (data: LockQuestionsByFormIdForMeasureProps) =>
      await lockQuestionsByFormIdForMeasure(data),
    onSuccess: async () => await invalidateLoadQuestionByResourceId(params),
  })

  const lockQuestionsByFormIdForMeasureReq = async (
    data: LockQuestionsByFormIdForMeasureProps
  ) => {
    return mutation.mutateAsync(data)
  }

  return {
    lockQuestionsByFormIdForMeasure: lockQuestionsByFormIdForMeasureReq,
    ...mutation,
  }
}
